<template>
    <!--进度显示-->
    <div v-if="processList.length>0" class="process-wrap">
        <div class="process-title">
            <span>操作列表</span>
            <span @click="processWrapClick">
                <i class="el-icon-minus" v-if="processWrap"></i>
                <i class="el-icon-plus" v-else></i>
            </span>
        </div>
        <el-scrollbar wrap-style="color: red;height:150px;" view-class="view-box" :native="false" v-if="processWrap" class="process-content">
            <div v-for="item,orderid in processList" :key="orderid" class="process-item">
                <div class="left">
                    <div class="title" :style="{'color':item.remote_status==201?'green':'red'}">
                        <span>站点编号:{{item.siteno}}</span>
                        <span>{{item.des}}</span>
                        <span>状态:{{item.remote_status}}</span>
                    </div>
                    <el-progress :text-inside="true" :stroke-width="26" :percentage="item.process" :show-text="false"></el-progress>
                </div>
                <div class="close" :style="{'color':item.remote_status==201?'green':'red'}">
                    <i class="el-icon-circle-close" v-if="item.remote_status!=201"></i>
                    <i class="el-icon-circle-check" v-else></i>
                </div>
            </div>
        </el-scrollbar>
    </div>
</template>

<script>
/**
 * 充值进度显示
 */

import {getProcessing} from "@api/billing";

export default {
    name:"proccess",
    data(){
        return {
            processWrap:true, // 传输列表是否显示
            processList:[], // 数据

            timeid:null, // 定时器id
        }
    },
    mounted(){
        // 获取数据列表
        this.getDataList();
        // 监听事件启动
        this.$bus.$on("processing",this.getDataList);
    },
    methods:{
        // 传输列表开关
        processWrapClick(){
            this.processWrap=!this.processWrap;
        },
        // 获取全部正在处理的信息
        getDataList(type){
            // 请求数据
            getProcessing().then(res=>{
                if(res.status&&res.status==200){
                    this.processList=res.content;
                }
                // 判断是否已经为空，如果出现了错误，不应该结束定时器
                if(this.processList.length<=0){
                    this.$message({
                        type:"success",
                        message:"没有正在进行的操作"
                    });

                    // 执行数据刷新
                    switch(type){
                        case "recharge":
                            this.$bus.$emit("updateRechargeList"); // 充值列表
                            break;
                        case "price":
                            this.$bus.$emit("updatePriceList"); // 单价修改列表
                            break;
                        case "relaycontrol":
                            this.$bus.$emit("updateRelayRecord"); // 操作列表
                            break;
                        case "relaystatus":
                            this.$bus.$emit("updateRelayStatus"); // 操作列表
                            break;
                    }

                    // 清空定时器
                    if(this.timeid){
                        clearTimeout(this.timeid);
                        this.timeid=null;
                    }
                }else{ // 启动定时器，查询数据
                    this.timeid=setTimeout(()=>{
                        this.getDataList(type);
                    },5*1000);
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
/** 进度 */
.process-wrap{
    position: fixed;
    bottom: 10px;
    max-height: 200px;
    right: 10px;
    padding: 10px;
    border:1px solid #1376eb;
    border-radius: 5px;
    width: 250px;
    background: #fff;
    z-index: 10000;

    .process-title{
        display: flex;
        font-size: 14px;
        justify-content: space-between;

        i{
            cursor: pointer;
        }
    }

    .process-content{
        margin-top:10px;
    }

    .process-item{
        display: flex;
        align-items: center;
        padding-bottom: 8px;
        border-bottom: 1px solid #EEF;
        
        .left{
            display: flex;
            flex-direction: column;
            font-size: 12px;
            width: 100%;

            .title{
                display: flex;
                display: flex;
                justify-content: space-between;
                margin-bottom: 4px;
            }

            .el-progress-bar__outer{
                height: 15px!important;
            }
        }
        .close{
            margin-left: 10px;
            font-size: 20px;
            cursor: pointer;
            color: red;
        }
    }
}
</style>